/**
 *
 * Styles for VatInfoMessage
 *
 */

import styled from "styled-components";
import { DhlLink } from "@dhl-official/react-library";

export const StyledMessage = styled.span`
  color: var(--dui-color-red-500);
  background-color: var(--dui-color-white-500);
  border: 1px solid var(--dui-color-red-500);
  padding: var(--dui-size-space-2x) var(--dui-size-space-5x);
  font-size: var(--dui-size-font-2xs) !important;
  line-height: var(--dui-size-line-height-xs) !important;
`;

export const StyledMessageWCC = styled(DhlLink)`
  line-height: var(--dui-size-line-height-xs) !important;
  font-size: var(--dui-size-font-2xs) !important;

  & > dhl-button {
    font-size: inherit !important;
    line-height: inherit !important;

    & .styled.md:is(button, a) {
      padding: 0 !important;
      font-size: inherit !important;
      line-height: inherit !important;
      border-radius: 0 !important;
      border: 0 !important;

      & span {
        font-size: inherit !important;
        line-height: inherit !important;
        text-decoration: none !important;
        font-weight: 400 !important;
      }

      &:hover span {
        text-decoration: underline !important;
      }
    }
  }
`;
